import { styled } from 'styled-components';

export const Title = styled.h1`
  color: #ffffff;
  margin: 0 0 10px 0;
  font-size: 36px;
  text-align: center;
`;

export const Subtitle = styled.h2`
  color: #ffffff;
  margin: 0 0 20px 0;
  font-size: 18px;
  text-align: center;
  opacity: 1; /* Fully opaque */
`;

export const SubBlock = styled.h3`
  color: #ffffff;
  margin: 0 10px 20px 10px;
  font-size: 14px;
  text-align: justify;
  opacity: 1; /* Fully opaque */
`;

export const ValueLabel = styled.span`
  color: #fff;
  font-size: 12px;
  margin-left: 5px;
`;

export const SetupHeader = styled(Title)`
  font-size: 32px;
  margin-bottom: 10px;
`;

export const SectionTitle = styled(Subtitle)`
  text-align: left;
  margin-bottom: 10px;
`;
